import { render } from "./SelectionDatagridSelectionSharedRow.vue?vue&type=template&id=22237402"
import script from "./SelectionDatagridSelectionSharedRow.vue?vue&type=script&lang=js"
export * from "./SelectionDatagridSelectionSharedRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__